import * as React from 'react';
import { Link } from '@react-pdf/renderer';
import { WpdfText } from '../../../datenauswertung/pdf/WpdfText.';


export function createLink(isPdf: boolean, title: string, url: string) {
    return isPdf ?
        <WpdfText pdf={isPdf}>
        <Link
            src = {url}
        > {title}</Link>
        </WpdfText>
    :
        <span><a
            target='_blank'
            href={url}>
                 {title}
        </a></span>;
}
